<template>
  <div class="tw-mt-2 tw-space-y-1">
    <p class="tw-mb-1 tw-text-xs tw-font-medium tw-text-slate-600 dark:tw-text-slate-300">Password requirements</p>
    <div
      v-for="requirement in requirements"
      :key="requirement.key"
      class="tw-flex tw-items-center tw-gap-2 tw-text-xs"
      :data-testid="`password-requirement-${requirement.key}`"
    >
      <span
        :class="[
          'tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-text-[10px] tw-font-bold',
          requirement.isValid
            ? 'tw-bg-green-100 tw-text-green-600 dark:tw-bg-green-900 dark:tw-text-green-400'
            : 'tw-bg-red-100 tw-text-red-600 dark:tw-bg-red-900 dark:tw-text-red-400'
        ]"
      >
        {{ requirement.isValid ? '✓' : '✗' }}
      </span>
      <span
        :class="[
          requirement.isValid ? 'tw-text-green-600 dark:tw-text-green-400' : 'tw-text-red-600 dark:tw-text-red-400'
        ]"
      >
        {{ requirement.label }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';

import { getPasswordRequirements, PasswordRequirement } from '@/utils/password';

export default defineComponent({
  name: 'PasswordStrengthIndicator',
  props: {
    password: {
      type: String as PropType<string>,
      required: true
    }
  },
  setup(props) {
    const requirements = computed<PasswordRequirement[]>(() => {
      return getPasswordRequirements(props.password);
    });

    return {
      requirements
    };
  }
});
</script>
